if (typeof window !== 'undefined') {
  ;(window as any).renderEHApp(document.getElementById('app'))
}
